import { createFileRoute } from "@tanstack/react-router";
import { MaaledataSimuleringPage } from "@/features/maaledata/simulering/MaaledataSimuleringPage";

export const Route = createFileRoute("/_app/_subheader/maalerdata/simulering")({
  component: MaaledataSimuleringPage,
  head: () => ({
    meta: [
      {
        title: "Simulering | Selskapsportal for fjernvarme",
      },
    ],
  }),
});
